var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2779 13.8892C17.9527 13.8892 18.519 14.446 18.4158 15.1123C17.8106 19.0323 14.4548 21.9429 10.4074 21.9429C5.92952 21.9429 2.30005 18.3134 2.30005 13.8365C2.30005 10.1481 5.10215 6.71233 8.25689 5.93549C8.93479 5.76812 9.62952 6.24496 9.62952 6.94286C9.62952 11.6713 9.78847 12.8944 10.6864 13.5597C11.5843 14.225 12.64 13.8892 17.2779 13.8892Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6926 9.9516C21.7463 6.91371 18.0147 2.01687 13.4674 2.10108C13.1137 2.10739 12.8305 2.40213 12.8147 2.75476C12.7 5.25266 12.8547 8.4895 12.9411 9.95687C12.9674 10.4137 13.3263 10.7727 13.7821 10.799C15.2905 10.8853 18.6453 11.0032 21.1074 10.6306C21.4421 10.58 21.6874 10.2895 21.6926 9.9516Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAlt);
export default __webpack_public_path__ + "static/media/dashboard_alt.82579503.svg";
export { ForwardRef as ReactComponent };